import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { Paper } from "@material-ui/core";

import Home from "./components/Home";
import Currency from "./components/Currency";
import CurrencyList from "./components/CurrencyList";
import About from "./components/About";
import Default from "./components/Default";
import News from "./components/News";
import Header from "./components/Common/Header";
import Footer from "./components/Common/Footer";

function App() {
  const [mode, setMode] = React.useState("light");
  const [currentPath, setCurrentPath] = React.useState("");

  const theme = createTheme({
    palette: {
      primary: {
        main: "#05ce91",
      },
      secondary: {
        main: "#005bff",
      },
      type: mode,
    },
    //typography: {},
  });

  return (
    <Paper style={{ minHeight: "100vh", borderRadius: 0 }}>
      <ThemeProvider theme={theme}>
        <Router>
          <Header currentPath={currentPath} />
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/currencies">
              <CurrencyList setCurrentPath={setCurrentPath} />
            </Route>
            <Route path="/currency/:cname" component={Currency} />
            <Route path="/about">
              <About setCurrentPath={setCurrentPath} />
            </Route>
            <Route path="/news">
              <News setCurrentPath={setCurrentPath} />
            </Route>
            <Route component={Default} />
          </Switch>
          <Footer />
        </Router>
      </ThemeProvider>
    </Paper>
  );
}

export default App;
